import { Component } from '@angular/core';

@Component({
  selector: 'app-current-invoices-report',
  standalone: true,
  imports: [],
  templateUrl: './current-invoices-report.component.html',
  styleUrl: './current-invoices-report.component.scss'
})
export class CurrentInvoicesReportComponent {

}
